import { AccommodationObject } from "../api/accommodation.api";
import { AccommodationEntity } from "../../domain/Accommodation.entity";

export function asObject(props: AccommodationObject): AccommodationEntity {
  return AccommodationEntity.of({
    id: props.id,
    ticker: props.ticker,
    type: props.type,
    translationsList: props.translationsList,
    active: props.active,
    multimediaList: props.multimediaList.map(it => {
      return Object.assign(new File([""], it.filename), {
        id: it.id,
        url: it.url,
        filename: it.filename,
        labels: it.labelsList,
        caption: it.caption,
        translations:
          (it.translationsList &&
            it.translationsList.length &&
            it.translationsList.reduce((accum, curr) => {
              const locale = curr.locale;
              return {
                ...accum,
                [locale]: {
                  title: curr.title,
                  description: curr.description,
                },
              };
            }, {})) ||
          {},
      });
    }),
    occupancyCombinationsList: props.occupancyCombinationsList,
    accommodationBaseAdults: props.accommodationBaseAdults || 0,
    occupancy: props.occupancy,
    customOccupancy: props.occupancy && {
      maxOccupancy: props.occupancy.maxOccupancy,
      maxOccupancyByType: props.occupancy.maxOccupancyByType,
      occupancyCombinationsList: props.occupancyCombinationsList,
    },
  });
}
